"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chip = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const material_1 = require("@mui/material");
const react_1 = require("react");
const fontawesome_icon_1 = require("./fontawesome-icon");
// @todo
// Handle displaying icons on the right. MUI Chip only
// allows the delete icon can be displayed on the right when onDelete prop
// is passed in
// @see https://github.com/mui/material-ui/blob/master/packages/mui-material/src/Chip/Chip.js#L444-L448
exports.Chip = (0, react_1.forwardRef)(({ sx = [], icon: startIcon, color = "gray", hasCircleStartIcon, rectangular, ...props }, ref) => {
    return ((0, jsx_runtime_1.jsx)(material_1.Chip, { ref: ref, color: color, sx: [
            ({ palette }) => ({
                ...(rectangular && {
                    borderRadius: 0.5,
                }),
                // circle start icon has a lighter shade compared to the shade
                // applied by default to the icon class
                ...(hasCircleStartIcon && {
                    [`& .${material_1.chipClasses.icon}`]: {
                        color: palette[color][50],
                    },
                }),
            }),
            ...(Array.isArray(sx) ? sx : [sx]),
        ], icon: hasCircleStartIcon ? (0, jsx_runtime_1.jsx)(fontawesome_icon_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faCircle }) : startIcon, ...props }));
});
